import React, { useState } from 'react';
import PropTypes from 'prop-types';
import searchIcon from 'assets/images/icons/search.svg';
import TextField from 'components/form-components/TextField';
import TaskSubmissionsActions from './TaskSubmissionsActions';

const TaskSubmissionsHeader = ({
  setFilter,
  selectedRows,
  actionsCallBack,
  webPagePayloadDetails,
}) => {
  const [searchText, setSearchText] = useState('');

  const handleFilterChange = (name, value) => {
    setFilter((prevState) => ({ ...prevState, [name]: value }));
  };

  return (
    <div className='mb-2 d-flex justify-content-between'>
      <div className='d-flex gap-2'>
        <TextField
          value={searchText}
          name='searchText'
          handleChange={(_, value) => setSearchText(value)}
          placeholder={'field_search'}
          icon={searchIcon}
          debounceFunc={handleFilterChange}
          shrink
        />

        <TaskSubmissionsActions
          ids={selectedRows}
          isActionButton={false}
          actionsCallBack={actionsCallBack}
          webPagePayloadDetails={webPagePayloadDetails}
        />
      </div>
      <div></div>
    </div>
  );
};

TaskSubmissionsHeader.propTypes = {
  selectedRows: PropTypes.array.isRequired,
  actionsCallBack: PropTypes.func,
  setFilter: PropTypes.func.isRequired,
  webPagePayloadDetails: PropTypes.object,
};

export default TaskSubmissionsHeader;
